import type { ReactElement } from 'react';
import React from 'react';
import { MfaCodeVerification } from '@hotjar/webapp/features/Mfa/components';
import { Button } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useMfaCodeVerification } from '@hotjar/webapp/hooks/mfa';
import { MfaEnforceEnableMfaPageStyles } from '../style';

const { Title, Description, ActionBar, VerificationWrapper } = MfaEnforceEnableMfaPageStyles;

interface QrCodeStepProps {
  userId: number;
  onBack: () => void;
  onNext: () => void;
}

export const CodeVerificationStep = ({ userId, onBack, onNext }: QrCodeStepProps): ReactElement => {
  const { t } = useTranslationWithPrefix('mfa:enforce-mfa.code-verification');

  const onEnabled = () => {
    onNext();
  };

  const { handleChange, handleInput, submit, isLoading, error } = useMfaCodeVerification(
    userId,
    onEnabled,
  );

  return (
    <>
      <Title>{t('title')}</Title>
      <Description>{t('description')}</Description>

      <VerificationWrapper>
        <MfaCodeVerification error={error} onChange={handleChange} onInput={handleInput} />
      </VerificationWrapper>

      <ActionBar marginTop="x4">
        <Button kind="secondary" onClick={onBack}>
          {t('back')}
        </Button>
        <Button kind="primary" isLoading={isLoading} onClick={submit} type="submit">
          {t('action')}
        </Button>
      </ActionBar>
    </>
  );
};
